import React, { useEffect, useState } from "react";
import { useSearch } from "../../../Contexts/SearchContext";
import {
  getActiveFilters,
  setFilterState,
  updateDropdownHeadingLabels,
} from "../../../../helpers";
import "./FilterDrawerAccordion.scss";

const FilterDrawerAccordion = ({
  data,
  subMenuClass,
  index,
  sortTypeApplied,
}) => {
  const { state, dispatch } = useSearch();

  const { filteredResults, selectedFilters, componentElement } = state;

  useEffect(() => {
    updateDropdownHeadingLabels(componentElement);
  }, [selectedFilters]);

  const [isActive, setIsActive] = useState(false);
  const [selectedFiltersHeadingsLocal, setSelectedFiltersHeadingsLocal] =
    useState([]);

  let isActiveClass = isActive ? " active" : "";

  const trackFilterCheckForDataLayer = (checkbox) => {
    let filterTitle = checkbox.nextSibling?.textContent;
    let filterCategory = checkbox
      ?.closest(".cmp-accordion__item, .cmp-accordion__sub-item")
      ?.querySelector(".cmp-accordion__title")?.textContent;

    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchFilterApplied,
      linkDetails: {
        clickName: 'Search Refinement Actions',
        clickType: `Filter Checkbox ${filterCategory}`,
        clickLocation: 'Product Finder Filter Rail',
        filter: {
          category: `filter by ${filterCategory}`,
          values: filterTitle
        }
      }
    });
  };

  const updateFilters = (event) => {
    let checkbox = event.target;
    let parent = checkbox.closest(".cmp-accordion__content-item");

    if (checkbox.checked) {
      trackFilterCheckForDataLayer(checkbox);
    }

    let localCheckedFilters = getActiveFilters(parent, dispatch);
    setSelectedFiltersHeadingsLocal(localCheckedFilters);

    setFilterState(checkbox.value, componentElement, checkbox.checked);

    dispatch({
      type: "UPDATE_SELECTED_FILTERS",
      payload: getActiveFilters(componentElement),
    });
  };

  const getLocalFilterHeadings = () => {
    return selectedFiltersHeadingsLocal
      .map((filter) => {
        return filter.label;
      })
      .join(", ");
  };

  const totalCount = data.filters.reduce((total, filter) => {
    if (filter && filter.label.trim() !== "") {
      const count = filteredResults && filteredResults.length > 0 
        ? filteredResults.filter((result) => {
            return (
              result.Fields.formattedPageTags.Value.indexOf(`"tagId":"${filter.tagPath}"`) >= 0
              || result.Fields.formattedPageTags.Value.indexOf(`'tagId':'${filter.tagPath}'`) >= 0
            );
          }).length
        : 0;
      return total + count; // Add the current filter count to the running total
    }
    return total;
  }, 0);
  
  //added
  useEffect(() => {
    if (state.type === "RESET_FILTERS") {
        setSelectedFiltersHeadingsLocal([]);
        dispatch({ type: "UPDATE_SELECTED_FILTERS", payload: [] });
    }
}, [state]);

  useEffect(() =>{
    if(!totalCount){
      setIsActive(false)
    }
  }, [filteredResults]);

  if (data && data.filters.length > 0) {
    return (
      <div
        className={`cmp-accordion__${subMenuClass}item${
          isActive ? " open" : ""
        }`}
      >
        <button
          aria-expanded={isActive ? "true" : "false"}
          aria-controls={"accordion-item-" + index}
          className="cmp-accordion__title-button cmp-accordion-title-heading"
          disabled={!totalCount}
          onClick={() => setIsActive(!isActive)}
        >
          <div className="cmp-accordion__dropdown-heading">
            <div className={`cmp-accordion__title ${!totalCount ? "text-disabled" : ""}`}>{data.label}</div>
            <div className="cmp-accordion__selected-filters-heading hide-title">
              {getLocalFilterHeadings()}
            </div>
            <span className={`chevron${isActiveClass} ${!totalCount ? "text-disabled" : ""}`}></span>
          </div>
        </button>
        <div className="cmp-accordion__content" id={"accordion-item-" + index}>
          <ul>
          <li className="cmp-accordion__content-item">
              {data.filters.map((filter) => {
                if (filter && filter.label.trim() !== "") {
                  const count = filteredResults && filteredResults.length > 0 
                  ? filteredResults.filter((result) => {
                      return (
                        result.Fields.formattedPageTags.Value.indexOf(`"tagId":"${filter.tagPath}"`) >= 0
                        || result.Fields.formattedPageTags.Value.indexOf(`'tagId':'${filter.tagPath}'`) >= 0
                      );
                    }).length
                  : 0;
                  return (
                    <label className={`${!count ? "hide"  : ""}`}>
                      <input
                        type="checkbox"
                        value={filter.tagPath}
                        data-heading-filter-title={filter.label}
                        onChange={updateFilters}
                       />
                      <p>{filter.label} <span className="filter-count">
                        ({count})
                      </span></p>
                    </label>
                  );
                } else {
                  return <></>;
                }
              })}
            </li>
          </ul>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default FilterDrawerAccordion;
